import React from 'react';

import {
  Action,
  Actions,
  FileDownloadIcon,
  ActionBar,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useScreenState, useScreenTitle } from '@gogame/screens';

import { useExportParentCampaigns } from 'scenes/Campaigns/ParentCampaigns/data';

export default () => {
  const [screenTitle] = useScreenTitle();
  const screenState = useScreenState();
  const [exportCampaigns] = useExportParentCampaigns();

  const handleExport = async () => {
    const { filters, tableSettings, searchQuery } = screenState;

    const params = {
      filters,
      tableSettings,
      searchQuery,
    };

    await exportCampaigns(params);
  };

  return (
    <ActionBar
      title={screenTitle}
      search={
        <SearchField
          tooltip={'Search by name, id or GG Campaign id'}
          applyFilters={true}
        />
      }
      secondaryActions={
        <Actions>
          <Action
            icon={<FileDownloadIcon />}
            label={'Export Campaigns'}
            onClick={handleExport}
          />
          <Action component={FullScreenToggler} />
        </Actions>
      }
    />
  );
};
